import { useState } from "react";
import Footer from "./Footer";
import BottomBarIcons from "./BottomBarIcons";
import Header from "./Header";
import Sidebar from "./Sidebar";
import { useNavigate, useParams, generatePath } from "react-router-dom";
import { dummyPlans } from "./common/constant";
import ConfirmationPopup from "./common/ConfirmationPopup";
import useGetClientId from "../hooks/useGetClientId";
import {
  //PAYMENT_CREATE_SESSION,
  ADD_SUBSCRIPTION_POINTS,
} from "../api/apiPath";
import http from "../api/server";
import { useSelector } from "react-redux";
import SidebarIcons from "./SidebarIcons";

const Subscription = () => {
  const { clientNameParam } = useParams();
  const [hideSidebar, setHideSidebar] = useState(true);
  const { userObj } = useSelector((state) => state.user);
  const [showConfirmationPopup, setShowConfirmationPopup] = useState(false);
  const [showConfirmationPopup2, setShowConfirmationPopup2] = useState(false);
  const [confirmMessage, setConfirmMessage] = useState("");
  // const [selectedPlanIndex, setSelectedPlanIndex] = useState(0); // Track selected plan
  const selectedPlanIndex = 0;
  const [selectedPlanPrice, setSelectedPlanPrice] = useState("");
  const [rawValue, setRawValue] = useState("");
  const navigate = useNavigate();
  const clientObj = useGetClientId();

  // useEffect(() => {
  //   setUserObj({ name: "Subscription" });
  // }, []);

  // const createPaymentSession = async () => {
  //   try {
  //     const payload = {
  //       clientId: clientObj?.clientId,
  //       userId: userObj?.userId,
  //       amount: parseFloat(selectedPlanPrice),
  //     };
  //     const response = await http.post(PAYMENT_CREATE_SESSION, payload);
  //     if (response?.status === 200) {
  //       setShowConfirmationPopup(false);
  //       window.location.href = response?.data?.sessionUrl; // Redirect to the payment URL
  //     }
  //   } catch (error) {
  //     console.error("Error fetching QR code:", error);
  //   }
  // };

  const addSubscriptionPoints = async () => {
    try {
      const payload = {
        clientId: clientObj?.clientId,
        userId: userObj?.userId,
        amount: parseFloat(selectedPlanPrice),
      };
      const response = await http.post(ADD_SUBSCRIPTION_POINTS, payload);
      if (response?.status === 200) {
        setShowConfirmationPopup2(true);
        setConfirmMessage(`Subscription successful! ${selectedPlanPrice} points have been added to your account.`);
        setRawValue(""); setSelectedPlanPrice("")
      }
    } catch (error) {
      console.error("Error fetching QR code:", error);
    }
  };
  // const formatToPound = (val) => {
  //   const num = parseFloat(val.replace(/[^0-9.]/g, ''));
  //   if (isNaN(num)) return '';
  //   return new Intl.NumberFormat('en-GB', {
  //     style: 'currency',
  //     currency: 'GBP',
  //     minimumFractionDigits: 2,
  //   }).format(num);
  // };

  const formattedValue = rawValue
    ? `£${Number(rawValue).toLocaleString("en-GB", {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      })}`
    : "";

  const handleChange = (e) => {
    const cleaned = e.target.value.replace(/[^0-9]/g, "");
    setRawValue(cleaned);
    // setSelectedPlanPrice(cleaned);
  };
  return (
    <>
      <Header hideSidebar={hideSidebar} setHideSidebar={setHideSidebar} />
      <ConfirmationPopup
        show={showConfirmationPopup}
        headingText="Confirmation"
        infoText={confirmMessage}
        cancelText="Cancel"
        submitText="Confirm"
        onCancel={() => {
          setShowConfirmationPopup(false);
        }}
        onSubmit={() => {
          setShowConfirmationPopup(false);
          setConfirmMessage("")
          addSubscriptionPoints();
        }}
      />
      <ConfirmationPopup
        show={showConfirmationPopup2}
        headingText="Confirmation"
        infoText={confirmMessage}
        cancelText="Cancel"
        submitText="Confirm"
        onCancel={() => {
          setShowConfirmationPopup2(false);
        }}
        onSubmit={() => {
          setShowConfirmationPopup2(false);
          setConfirmMessage("")
        }}
      />
      {userObj && (
        <div className="dashboard_body_main d-flex vh-100">
          {hideSidebar ? (
            <Sidebar
              setHideSidebar={setHideSidebar}
              hideSidebar={hideSidebar}
            />
          ) : (
            <SidebarIcons />
          )}

          <div className="d-flex dashboard_body flex-column w-100">
            <div className="px-4 py-3 d-flex justify-content-start">
              <button
                className="btn btn-secondary"
                onClick={() =>  navigate(
                      generatePath("/client/:clientNameParam/ClientDashboard", {
                        clientNameParam,
                      })
                    )}
              >
                Back
              </button>
            </div>

            <div className="col-12 d-flex flex-column align-items-center">
              <h2 className="mb-0">Our Subscription Plans</h2>
              <p className="fs-6 text-center w-75"></p>
            </div>

            <div className="row text-center justify-content-center m-0">
              {dummyPlans?.map((plan, index) => (
                <div className="col-12 col-sm-6 col-lg-4 mb-4" key={index}>
                  <div
                    className={`card h-100 cursor-pointer ${
                      selectedPlanIndex === index
                        ? "border-success shadow-lg"
                        : ""
                    }`}
                    // onClick={() => setSelectedPlanIndex(index)}
                    // style={{ cursor: "pointer" }}
                  >
                    <div className="card-body d-flex flex-column">
                      <h4 className="content-start">{plan.title}</h4>
                      <div className="content-start mb-2">
                        <input
                          type="text"
                          // ref={(el) =>
                          //   (mandatoryFieldRef.current.doorMaterialOther = el)
                          // }
                          className="form-control"
                          id="floatingInputValue"
                          name="priceInput"
                          placeholder="£0"
                          value={rawValue}
                          onBlur={() => setRawValue(formattedValue)}
                          onFocus={() =>
                            setRawValue(rawValue.replace(/[^0-9]/g, ""))
                          }
                          onChange={(e) => {
                            handleChange(e);
                          }}
                        />

                        {/* <h2 className="d-inline ms-3">{plan.price}</h2> */}
                        {/* <span className="ms-1">/month</span> */}
                      </div>
                      <span className="text-start">
                        {rawValue.replace(/[^0-9]/g, "")} Points
                      </span>
                      <span className="text-start mt-1">Key features:</span>
                      <ul className="mb-4 ps-3 ms-3 text-start">
                        {plan.features.map((feature, i) => (
                          <li key={i}>{feature}</li>
                        ))}
                      </ul>
                      <button
                        className={`btn ${
                          selectedPlanIndex === index
                            ? "btn-primary"
                            : "btn-secondary"
                        } w-100 mb-3`}
                        type="button"
                        disabled={!rawValue || rawValue === "0"}
                        onClick={() => {
                          setShowConfirmationPopup(true);
                          setConfirmMessage(
                            "Thank you for choosing a plan! You're one step closer to unlocking great features. Please confirm your selection to proceed."
                          );
                          setSelectedPlanPrice(rawValue.replace(/[^0-9]/g, ""));
                        }}
                      >
                        {selectedPlanIndex === index
                          ? "Subscribe"
                          : "Subscribe"}
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <Footer />
<div className="bottom-bar-spacing"></div>
<BottomBarIcons />
          </div>
        </div>
      )}
    </>
  );
};

export default Subscription;
